<template>
  <v-btn class="p-button" v-bind="$attrs" :variant="variant" :size="size">
    <span :class="iconClass"></span>
    <slot></slot>
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  appkitIcon: string;
  size?: string | number;
  variant?: "flat" | "text" | "elevated" | "tonal" | "outlined" | "plain";
}>();

const iconClass = computed(() => {
  return "Appkit4-icon " + props.appkitIcon;
});
</script>
